export default "__VITE_ASSET__DAeRNKAx__"